import axios from "../../../lib/axios";
import { IArtist } from "../../../types/api/artist";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { AxiosResponse } from "axios";

export const artistList = (
  qData: QData & { search?: string; status?: string }
): Promise<AxiosResponse<TResponseWithQData<IArtist[]>>> => {
  return axios.get("/artist", {
    params: qData,
  });
};

export const artistDetail = (id: string): Promise<AxiosResponse<TResponse<IArtist>>> => {
  return axios.get(`/artist/${id}`);
};

export const createArtist = (
  data: Partial<IArtist>
): Promise<AxiosResponse<TResponse<IArtist>>> => {
  return axios.post("/artist", data);
};

export const updateArtist = ({
  id,
  data,
}: {
  id: string;
  data: Partial<IArtist>;
}): Promise<AxiosResponse<TResponse<IArtist>>> => {
  return axios.put(`/artist/${id}`, data);
};

export const deleteArtist = (id: string): Promise<AxiosResponse<TResponse<IArtist>>> => {
  return axios.delete(`/artist/${id}`);
};

export interface IBulkInviteLink {
  artistId: string;
  name: string;
  email: string;
  link: string;
}

export interface IBulkInviteResult {
  invites: IBulkInviteLink[];
  sent: number;
  failed: { email: string; error: string }[];
}

export const generateBulkInviteLinks = (): Promise<AxiosResponse<TResponse<IBulkInviteResult>>> => {
  return axios.post("/artist/invite/bulk");
};
